import React from 'react';
import dayjs from "dayjs"
import style from "../styles/chat.module.sass"
import { FileExtensions, MessageAttachmentProps, MessageItemProps } from '../interfaces/interfaces';
import { Progress } from 'antd';
import type { MenuProps } from 'antd';
import { Dropdown } from 'antd';
import { useChat } from '../contexts/ChatContext';

const docsFileUrl = 'https://curiobites-media.s3.ap-southeast-1.amazonaws.com/icons/docs.png';
const excelFileUrl = 'https://curiobites-media.s3.ap-southeast-1.amazonaws.com/icons/excel.png';
const pdfFileUrl = 'https://curiobites-media.s3.ap-southeast-1.amazonaws.com/icons/pdf.png';
const audioFileUrl = 'https://curiobites-media.s3.ap-southeast-1.amazonaws.com/icons/audio.png';
const zipFileUrl = 'https://curiobites-media.s3.ap-southeast-1.amazonaws.com/icons/zip.png';
const textFileUrl = 'https://curiobites-media.s3.ap-southeast-1.amazonaws.com/icons/text.png';


export const MessageItem = (props: MessageItemProps) => {
    const { message, user, showTime, room, setMessages, messages } = props;
    const { setReplyMessage, roomSocket: socket } = useChat()
    // console.log('message', message, user)
    const isUnread = !message.read && message.sender !== user.id;
    const classes = isUnread ? `${style.chat_message_item} ${style.unread}`
        : message.sender === user.id ?
            `${style.chat_message_item}  ${style.self} message-item-self`
            : style.chat_message_item


    const handleCopy = () => {
        console.log('message copy', message)
        navigator.clipboard.writeText(message.message)
    }

    const handleReply = () => {
        console.log('message reply', message)
        setReplyMessage(message)
    }

    const handleDelete = () => {
        console.log('message delete', message)
        const data = {
            event_type: "DELETE_MESSAGE",
            message_id: message.id,
            room: room
        }
        if (socket) {
            socket.send(JSON.stringify(data))
            const updatedMessages = messages.filter(item => item.id !== message.id)
            setMessages(updatedMessages)
        }

    }

    const items: MenuProps['items'] = [
        {
            key: '1',
            label: <div onClick={handleCopy}><i className="lar la-copy mr-1"
                style={{ fontSize: ".9em", padding: 0 }}></i> Copy</div>
        },
        {
            key: '2',
            label: <div onClick={handleReply} ><i className="las la-reply mr-1"
                style={{ fontSize: ".9em", padding: 0 }}
            ></i> Reply</div>,
        },
        ...(message.sender === user.id ? [{
            key: '3',
            label: <div onClick={handleDelete}><i className="lar la-trash-alt mr-1"
                style={{ fontSize: ".9em", padding: 0 }}></i> Delete</div>,
        }] : [])
    ];

    return (
        <div className={message.sender === user.id ? `${style.message_item_holder} ${style.self}   ` : `${style.message_item_holder} ${isUnread ? style.unread_message_box : ""}`}
            data-id={message.id}>

            {showTime &&
                <div className={style.time_sent}>
                    {dayjs(message.date_create).format("HH:mm")}
                </div>
            }
            <div className={style.chat_message_item_box} >
                <div className={classes}>

                    {message.reply_message && message.reply_message.id &&
                        <div className={style.message_reply_message}>
                            <div>
                                <i className="las la-reply"

                                ></i>
                            </div>
                            <div className={style._text} >
                                {message.reply_message.message}
                            </div>
                            <div className={style.reply_to}>
                                {message.reply_message.user.name}
                            </div>
                        </div>
                    }

                    <div className={style.attachment}>
                        {message.files && message.files.map((item, index) => (
                            <MessageAttachment
                                url={item.url}
                                name={item.name}
                                key={item.url + index}
                                percent={item.percent} />
                        ))}
                    </div>

                    {message && message.message}
                </div>
                < div className={style.message_option + ` message_option`}>
                    <Dropdown menu={{ items }} placement="bottomRight" >
                        <i className="las la-ellipsis-v"></i>
                    </Dropdown>
                </div>
            </div>

        </div >
    );
};

export const MessageAttachment = (props: MessageAttachmentProps) => {
    const { url, name, className, percent = 0 } = props;
    const extension = name.split('.').pop(); // Get the file extension
    // const imageFileType = ["jpg", "jpeg", "png", "gif"]
    // const fileType = extension && imageFileType.includes(extension) ? "image" : "other"
    let fileUrl = ""

    if (extension) {
        fileUrl = getFileUrlByExtention(url, extension as FileExtensions)
    }

    return (
        <div className={percent ? `${style.attachment_item} ${style.uploading} ${className}` : `${style.attachment_item} ${className}`}>

            {percent > 0 && percent < 100 &&
                <div className={style.progress_box}>
                    <Progress
                        type="circle"
                        percent={percent}
                        size={30}
                        className='upload-attachment-progress'
                    />
                </div>
            }
            <a href={url} download target='_blank' title={name}>
                <img
                    src={fileUrl}
                    alt={name}
                    className={(percent && (percent < 100 && percent > 0)) ? `${style.in_process} ${className}` : className} />

                <div className={style.attachment_file_name + ` attachment-file-name`}>
                    {name}
                </div>

            </a>


        </div>
    )

}

export const getFileUrlByExtention = (url: string, extension: FileExtensions) => {
    // console.log('extension', extension)
    const extensionToUrl = {
        "jpg": url,
        "png": url,
        "jpeg": url,

        "docx": docsFileUrl,
        "doc": docsFileUrl,

        "xlsx": excelFileUrl,
        "xls": excelFileUrl,
        "csv": excelFileUrl,
        "xlsm": excelFileUrl,

        "pdf": pdfFileUrl,
        "mp3": audioFileUrl,
        "zip": zipFileUrl,
        "rar": zipFileUrl,

        "json": textFileUrl,
        "txt": textFileUrl,

    };

    return extensionToUrl[extension] || textFileUrl;

}
